import { ReservationDetailDate } from './reservation-detail-date';
import { AdUnit } from './adunit';

export class ReservationDetail {
    id: string;
    reservationId: string;
    adUnitId: string;
    reservationDetailDates: ReservationDetailDate[] = [];
    adUnit: AdUnit;
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/models/reservation-detail.ts